
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Head, Notes } from 'mdx-deck'
import { themes } from 'mdx-deck'
import custom from './custom'
import { TagList, Heading, Cross } from './custom'
import './global.css'
export const theme = { ...themes.yellow,
  ...custom,
  styles: { ...themes.yellow.styles,
    ...custom.styles
  }
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  theme
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Freelance or not?`}</h1>
    <h3>{`Entscheidungshilfe`}</h3>
    <hr></hr>
    <h2>{`Agenda`}</h2>
    <ul>
      <li parentName="ul">{`Wer redet?`}</li>
      <li parentName="ul">{`Wer hört zu?`}</li>
      <li parentName="ul">{`Grenzen des Talks`}</li>
      <li parentName="ul">{`Übersicht: Kriterien`}</li>
      <li parentName="ul">{`Kritierien: Diskussion`}</li>
      <li parentName="ul">{`Weitere Fragen`}</li>
    </ul>
    <hr></hr>
    <p>{`Wer redet?`}</p>
    <h2>{`Jeremias Erbs`}</h2>
    <ul>
      <li parentName="ul">{`Product Engineer`}</li>
      <li parentName="ul">{`15 Jahre im Business`}</li>
      <li parentName="ul">{`Mehrfach Freelancer und Angestellter`}</li>
      <li parentName="ul">{`Aktuell (freelance) Head Coach bei neuefische`}</li>
      <li parentName="ul">{`Finde mich bei Xing or LinkedIn`}</li>
    </ul>
    <hr></hr>
    <h2>{`Wer hört zu?`}</h2>
    <ul>
      <li parentName="ul">{`Spricht jemand kein deutsch? WTF you don't say anyting?`}</li>
      <li parentName="ul">{`Wer ist/wird Entwickler?`}</li>
      <li parentName="ul">{`Wer ist/wird Data Scientist?`}</li>
      <li parentName="ul">{`Andere Berufe?`}</li>
      <li parentName="ul">{`Wer ist Freelancer? Wer ist Angestellter?`}</li>
      <li parentName="ul">{`Wer ist aus Hamburg? Wer Köln? Andere?`}</li>
      <li parentName="ul">{`Was erwartet ihr? Was wäre hilfreich?`}</li>
    </ul>
    <hr></hr>
    <h2>{`Grenzen des Talks`}</h2>
    <p><inlineCode parentName="p">{`Deutschland`}</inlineCode>{` `}{`✓`}</p>
    <p><inlineCode parentName="p">{`Internet, Digital Products`}</inlineCode>{` `}{`✓`}</p>
    <p><inlineCode parentName="p">{`Entwicklung, Kreativberuf`}</inlineCode>{` `}{`✓`}</p>
    <hr></hr>
    <h2>{`Übersicht: Kriterien`}</h2>
    <TagList mdxType="TagList">
  <li>Stadt</li>
  <li>Karrierelevel</li>
  <li>Angestrebte Rolle</li>
  <li>Karriereleiter</li>
  <li>Sicherheit des Jobs</li>
  <li>Finanzielle Sicherheit</li>
  <li>Krankheit, Urlaub</li>
  <li>Rezession, Ruhestand</li>
  <li>Steuern</li>
  <li>Krankenversicherung</li>
  <li>Papierkram</li>
  <li>Arbeitsgesetze</li>
  <li>Unternehmenspolitik</li>
  <li>Verträge</li>
  <li>Jobauswahl</li>
  <li>Bewerbungsgespräche</li>
  <li>Persönlichkeit</li>
  <li>Teams</li>
  <li>Varianz im Job</li>
  <li>Homeoffice</li>
  <li>Hund mitbringen</li>
  <li>Lifestyle</li>
    </TagList>
    <hr></hr>
    <h1>{`Stadt`}</h1>
    <p><inlineCode parentName="p">{`Großstadt`}</inlineCode>{` `}{`✓`}</p>
    <ul>
      <li parentName="ul">{`Hamburg `}{`✓`}</li>
      <li parentName="ul">{`Köln `}{`✓`}</li>
      <li parentName="ul">{`... others `}{`✓`}</li>
      <li parentName="ul">{`Walldorf `}<Cross mdxType="Cross" /></li>
    </ul>
    <hr></hr>
    <h1>{`Karrierelevel`}</h1>
    <p><inlineCode parentName="p">{`Über Junior`}</inlineCode>{` `}{`✓`}</p>
    <ul>
      <li parentName="ul">{`Lernen`}</li>
      <li parentName="ul">{`Bezahltes Lernen`}</li>
      <li parentName="ul">{`Kollegen`}</li>
      <li parentName="ul">{`Kurze Verträge`}</li>
      <li parentName="ul">{`kein Vertrauen`}</li>
      <li parentName="ul">{`zu teuer`}</li>
    </ul>
    <hr></hr>
    <h1>{`Angestrebte Rolle`}</h1>
    <p><inlineCode parentName="p">{`Produkt`}</inlineCode>{` `}{`✓`}{` `}{` `}{` `}{` `}{` `}<inlineCode parentName="p">{`Menschen`}</inlineCode>{` `}<Cross mdxType="Cross" /></p>
    <ul>
      <li parentName="ul">{`Entwickler `}{`✓`}</li>
      <li parentName="ul">{`Kreativer `}{`✓`}</li>
      <li parentName="ul">{`Agile Coach `}{`✓`}</li>
      <li parentName="ul">{`Product Owner `}{`✓`}</li>
      <li parentName="ul">{`People Manager `}<Cross mdxType="Cross" /></li>
    </ul>
    <hr></hr>
    <h1>{`Karriereleiter`}</h1>
    <p><inlineCode parentName="p">{`Angestellter, aber wechselt`}</inlineCode>{` `}{`✓`}</p>
    <p><inlineCode parentName="p">{`Senior Freelancer`}</inlineCode>{` `}{`✓`}</p>
    <hr></hr>
    <h1>{`Sicherheit des Jobs`}</h1>
    <p><inlineCode parentName="p">{`Angestellter`}</inlineCode>{` `}{`✓`}</p>
    <p><inlineCode parentName="p">{`Entwickler`}</inlineCode>{` `}{`✓`}</p>
    <p><inlineCode parentName="p">{`Product Owner`}</inlineCode>{` `}{`✓`}</p>
    <p><inlineCode parentName="p">{`Agile Coach`}</inlineCode>{` `}{`✓`}</p>
    <p><inlineCode parentName="p">{`Andere Freelancer`}</inlineCode>{` `}<Cross text="🤷🏻‍♂️" mdxType="Cross" /></p>
    <hr></hr>
    <h1>{`Finanzielle Sicherheit`}</h1>
    <p><inlineCode parentName="p">{`Freelancer`}</inlineCode>{`: Mehr Geld, eigene Vorsorge`}</p>
    <p><inlineCode parentName="p">{`Angestellter`}</inlineCode>{`: "sicheres" Einkommen und Banken `}<span style={{
        color: 'crimson'
      }}>{`♥`}</span>{` dich`}</p>
    <hr></hr>
    <h1>{`Krankheit, Urlaub`}<br />{` Rezession, Ruhestand`}</h1>
    <ul>
      <li parentName="ul">{`12,1 `}{`ø`}{` Krankheitstage`}</li>
      <li parentName="ul">{`>`}{`30 Tage Ausgaben, kein Einkommen`}</li>
      <li parentName="ul">{`Ruhestand: > 400€ pro Monat (z.B. ETF)`}</li>
      <li parentName="ul">{`Rezession: 6 Monate in Gold`}</li>
    </ul>
    <hr></hr>
    <h1>{`Steuern`}</h1>
    <ul>
      <li parentName="ul">{`19% Umsatzsteuer`}</li>
      <li parentName="ul">{`max. 42% Einkommensteuer`}</li>
      <li parentName="ul"><strong parentName="li">{`kein`}</strong>{` Gewerbe`}</li>
    </ul>
    <p><strong parentName="p">{`Lege 40% für das Jahresende beiseite`}</strong></p>
    <hr></hr>
    <h1>{`Krankenversicherung`}</h1>
    <h3><inlineCode parentName="h3">{`GKV`}</inlineCode>{` `}{`✓`}{` `}{` `}{` `}{` `}{` `}<inlineCode parentName="h3">{`PKV`}</inlineCode>{` `}<Cross mdxType="Cross" /></h3>
    <ul>
      <li parentName="ul">{`GKV: 14.7 + 0.7 `}{`×`}{` max. 4.537,50 €`}</li>
      <li parentName="ul">{`GKV: zzgl. Pflegeversicherung ca. 3%`}</li>
      <li parentName="ul">{`GKV: max. 780 € – 820 € a month`}</li>
      <li parentName="ul">{`PKV: 350 € - 650 € pro Monat`}</li>
      <li parentName="ul">{`PKV: im Alter `}<em parentName="li">{`sehr`}</em>{` teuer`}</li>
    </ul>
    <hr></hr>
    <h1>{`Papierkram`}</h1>
    <ul>
      <li parentName="ul">{`monatliche Buchhaltung`}</li>
      <li parentName="ul">{`monatliche Einkommensteuervorauszahlung`}</li>
    </ul>
    <hr></hr>
    <h1>{`Arbeitsgesetze`}</h1>
    <ul>
      <li parentName="ul">{`Scheinselbständigkeit`}</li>
      <li parentName="ul">{`Weisungsgebundenheit`}</li>
      <li parentName="ul">{`Homeoffice: kein Problem`}</li>
    </ul>
    <hr></hr>
    <h1>{`Unternehmenspolitik`}</h1>
    <ul>
      <li parentName="ul">{`Keine Freelancer`}</li>
      <li parentName="ul">{`Keine Neuanstellungen`}</li>
      <li parentName="ul">{`Keine schönen Sachen (Tisch, Stuhl, Party) für Freelancer`}</li>
    </ul>
    <hr></hr>
    <h1>{`Verträge`}</h1>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Nein`}</strong>{` sagen zu Klauseln`}</li>
      <li parentName="ul">{`Für Mitbewerber arbeiten dürfen`}</li>
      <li parentName="ul">{`Keine Verantwortung für Kreativarbeit`}</li>
      <li parentName="ul">{`Keine Verantwortung für Timing des Unternehmens`}</li>
      <li parentName="ul">{`Keine Festpreise`}</li>
      <li parentName="ul">{`< 30 Tage Zahlungsziel `}<em parentName="li">{`nicht`}</em>{` erst auf Rechnung`}</li>
      <li parentName="ul">{`Gebuchte Tage = bezahlte Tage`}</li>
      <li parentName="ul">{`Jede Stunde abrechnen`}</li>
      <li parentName="ul">{`Haftpflichtversicherungen`}</li>
      <li parentName="ul">{`keine Software installieren = Rechner geben lassen`}</li>
    </ul>
    <hr></hr>
    <h1>{`Jobauswahl`}</h1>
    <ul>
      <li parentName="ul">{`Unternehmen `}<em parentName="li">{`ausprobieren`}</em>{` `}{`✓`}</li>
      <li parentName="ul">{`Jobs gezielt auspicken `}{`✓`}</li>
      <li parentName="ul">{`Kurze, anstrengende, gut bezahlte Jobs `}{`✓`}</li>
      <li parentName="ul">{`Schnell wieder raus sein `}{`✓`}</li>
    </ul>
    <hr></hr>
    <h1>{`Bewerbungsgespräche`}</h1>
    <p><inlineCode parentName="p">{`Verkaufe dich`}</inlineCode></p>
    <ul>
      <li parentName="ul">{`Selbstbewusstsein`}</li>
      <li parentName="ul">{`Kompetenz`}</li>
      <li parentName="ul">{`Hands-On sein`}</li>
      <li parentName="ul">{`Positive Vibes`}</li>
      <li parentName="ul"><em parentName="li">{`Introvertierte`}</em>{` werden `}<strong parentName="li">{`genau so`}</strong>{` gesucht`}</li>
    </ul>
    <hr></hr>
    <h1>{`Persönlichkeit`}</h1>
    <ul>
      <li parentName="ul">{`sich schnell einstellen können`}</li>
      <li parentName="ul">{`Menschenfreund`}</li>
      <li parentName="ul">{`Offen für Neues/Anderes`}</li>
      <li parentName="ul">{`Keine Politik`}</li>
      <li parentName="ul">{`Nicht an allem teilnehmen`}</li>
    </ul>
    <hr></hr>
    <h1>{`Teams`}</h1>
    <ul>
      <li parentName="ul">{`Kein festes Team`}</li>
      <li parentName="ul">{`Ohne Team arbeiten`}</li>
      <li parentName="ul">{`Nicht immer gewollt im Team`}</li>
      <li parentName="ul">{`Eifersüchtige Kollegen`}</li>
    </ul>
    <hr></hr>
    <h1>{`Varianz im Job`}</h1>
    <ul>
      <li parentName="ul">{`Kunden`}</li>
      <li parentName="ul">{`Industrien`}</li>
      <li parentName="ul">{`Arbeitsweisen`}</li>
      <li parentName="ul">{`Technologien`}</li>
      <li parentName="ul">{`Produkte`}</li>
      <li parentName="ul">{`Zielgruppen`}</li>
    </ul>
    <hr></hr>
    <h1>{`Homeoffice`}</h1>
    <ul>
      <li parentName="ul">{`Gesetz auf eurer Seite`}</li>
      <li parentName="ul">{`kann man geziehlt wählen`}</li>
      <li parentName="ul">{`kann gefährlich sein`}</li>
    </ul>
    <hr></hr>
    <h1>{`Hund mitbringen`}</h1>
    <ul>
      <li parentName="ul">{`Nicht alle Unternehmen mögen das`}</li>
      <li parentName="ul">{`Nicht alle Hunde können das`}</li>
    </ul>
    <hr></hr>
    <h1>{`Lifestyle`}</h1>
    <p>{`"Scheiß drauf, nächsten Monat bin ich weg"`}</p>
    <p>{`"Komm, ich lad dich ein – ich bin Freelancer"`}</p>
    <p>{`"Der Winter in Südafrika war angenehm"`}</p>
    <hr></hr>
    <h1>{`Mein Rat`}</h1>
    <p><inlineCode parentName="p">{`Einfach mal versuchen`}</inlineCode>{` `}{`✓`}</p>
    <p><inlineCode parentName="p">{`50% beiseite legen`}</inlineCode>{` `}{`✓`}</p>
    <p><inlineCode parentName="p">{`Lass uns was zusammen machen`}</inlineCode>{` `}{`✓`}</p>
    <hr></hr>
    <h1>{`Fragen`}</h1>
    <hr></hr>
    <h1>{`Danke euch!`}</h1>
    <p>{`Jeremias Erbs (`}<a parentName="p" {...{
        "href": "mailto:jerry@badabam.de"
      }}>{`jerry@badabam.de`}</a>{`)`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/badabam/freelance-or-not"
      }}>{`https://github.com/badabam/freelance-or-not`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://freelance-or-not.netlify.com/"
      }}>{`https://freelance-or-not.netlify.com/`}</a></p>
    <p>{`Bleibt gesund!`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;